import { useItemsCount } from "../../../fetch/fetch.item.ts";
import { useActiveParams } from "../../../hooks/useActiveParams";

export const useItemCount = () => {
  const { categorySlug, filter, status, user, search } = useActiveParams();
  const { count } = useItemsCount({
    categorySlug: categorySlug,
    filter: filter,
    status: status,
    user: user,
    search: search,
    fallback: 0,
  });

  return count;
};
